// ProfiloView.jsx — amm-v3 (A6, ondata 33): la vista "Profilo azienda" (pagina
// 'profilo', l'HUB) in React, flag-gated (shell_amm_v3_profilo, default OFF).
//
// SEAM = renderProfilo (viewId 'profilo'): l'INTERA pagina è UNA vista React
// (una sola flag per l'hub — spike o27 §2.2, motivazione in profilo-api.js).
//
// MIGRATE NATIVE (React): scheda azienda + 8 flag "Caratteristiche fiscali" +
// anteprima impatto (dry-run) + salva-e-rigenera; le 3 sotto-sezioni TABELLARI
// Tipologie / Parametri normativi / Proroghe (liste + "+ Nuovo" + elimina;
// EDITOR modali DELEGATI al v1 → payload IDENTICO per costruzione); e — ONDATA
// 37 (A7 completamento) — i 4 pannelli Promemoria email / Registro modifiche /
// Spazio allegati / Cestino, ora anch'essi NATIVI React (prima delegati ai
// renderX del v1).
//
// PANNELLI NATIVI A7 — parità campo-per-campo col v1: STESSE letture (stessi
// endpoint), STESSI testi (PA_TEXTS pinnati dal contract test), STESSI id/classi
// WORLD-AGNOSTIC (prom-tog/reg-f-entita/cest-rip…) così il proof li trova nei
// due mondi. Le SCRITTURE che nel v1 passano da una primitiva delegano:
//  - Promemoria SALVA → AMM.upsertParametroVigente ×5 (nessuna scrittura
//    reimplementata; NESSUNA password — il v1 espone solo l'email destinatario,
//    verificato: zero campi password in admin-module.js);
//  - Cestino RIPRISTINA → stesso endpoint del v1 (NON distruttivo). Il v1 NON
//    ha alcuno "svuota"/hard-delete del cestino: il nativo NON lo introduce.
// Spazio allegati e Registro modifiche sono di SOLA lettura (Registro: filtri +
// paginazione "mostra altri" limit/offset, come il v1).
//
// CONFINE (dichiarato): restano V1 SOLO i modali editTipologia/editParametro/
// editProroga (payload identico) e la primitiva di scrittura del Promemoria
// (upsertParametroVigente). Le liste native passano ai modali il PROPRIO onSaved
// (refresh della sola sezione) ⇒ mai renderProfilo diretto (niente interceptor).
// Le tabelle di configurazione del v1 sono SENZA intestazione: le replico fedeli
// (headerless) invece di forzare l'header del DataTable — parità visiva prima
// del riuso.
//
// DEVIAZIONI DICHIARATE (famiglia D-A1..A5):
//  D-A6.1 doppio click su "Salva e rigenera"/"Anteprima"/"+ Nuovo"/elimina/
//         Salva-Promemoria/Ripristina = 1 azione (guardia ref). Il v1 NON guarda
//         "Salva e rigenera" (onclick nudo, r.3133) ⇒ doppio salva = 2 PATCH: qui
//         1 sola (regole UI 5). Il Promemoria/Ripristina del v1 usano busy(): qui
//         guardia ref equivalente.
//  D-A6.2 caricamento scheda azienda fallito ⇒ StatoBox errore + Riprova (mai
//         vista bianca); il v1 lascerebbe la pagina rotta (await senza catch).
//  D-A6.5 "+ Nuova proroga" riusa le regole già caricate nella sezione invece
//         di ri-fetcharle (v1 r.3160) — stesso modale/payload, un GET in meno.
//  D-A7.1 pannelli nativi Promemoria/Cestino: errore di carico mostrato inline
//         (parità v1: 'Errore: …'/'Errore nel caricamento…'); Promemoria salva in
//         errore ⇒ messaggio vicino al campo + dati NON persi (restano nel form).

import React from 'react';
import { AM_NEW_TEXTS } from './api.js';
import {
  PA_TEXTS, FORMA_GIURIDICA, REGIME_IVA, BOOLS, IC_EDIT, IC_DEL, IC_WARN, ARROW,
  dd, boolStateIniziale, buildProfiloPayload, saveToast,
  anteprimaNuoveSuffix, anteprimaNonDovuteSuffix,
  parametroDaConfermare, parametroValiditaTxt, confirmParametro,
  prorogaTitoloRegola, prorogaDataOriginaleTxt,
  readProfilo, readTipologie, readParametri, readProrogheERegole,
  anteprima, salvaProfilo,
  apriNuovaTipologia, apriEditTipologia,
  apriNuovoParametro, apriEditParametro, eliminaParametro,
  apriNuovaProroga, apriEditProroga, eliminaProroga,
  // A7 (ondata 37) — 4 pannelli NATIVI
  STORIA_ENTITA_LABEL, CEST_ENTITA_LABEL, REG_LIMIT,
  humanBytes, fmtDataSola, fmtDataOra, fmtPromemoriaLog, origineBadge,
  registroContaTesto, cestinoContaTesto, vigenteDiParametro, pausaIncompleta,
  promemoriaSalvaErrMsg,
  readSpazio, readStoriaRegistro, readCestino, ripristinaCestino,
  readPromemoriaStato, salvaPromemoria, inviaProvaPromemoria,
} from './profilo-api.js';

function ErroreRicarica({ error, onRetry }) {
  return (
    <div className="dt-state dt-error" role="alert">
      <div className="dt-errmsg">{'⚠ ' + (error && error.message ? error.message : String(error))}</div>
      <button type="button" className="dt-retry" onClick={onRetry}>{AM_NEW_TEXTS.riprova}</button>
    </div>
  );
}

// intestazione di una sotto-sezione (label uppercase + eventuale bottone "+ Nuovo")
function SezioneHeader({ label, btnId, btnLabel, onNew }) {
  return (
    <div className="flex items-center justify-between mb-2">
      <div className="text-[11px] uppercase tracking-wider text-slate-400">{label}</div>
      {onNew ? <button id={btnId} type="button" className="bg-cyan-700 hover:bg-cyan-600 text-white text-xs px-3 py-1.5 rounded font-medium" onClick={onNew}>{btnLabel}</button> : null}
    </div>
  );
}

// ---------- SCHEDA AZIENDA (form + 8 flag + anteprima + salva) ----------
function SchedaAzienda({ win }) {
  const A = win.AMM;
  const [dati, setDati] = React.useState({ loading: true, error: null, p: null });
  const [reloadN, setReloadN] = React.useState(0);
  const [form, setForm] = React.useState(null);
  const [boolState, setBoolState] = React.useState({});
  const [ant, setAnt] = React.useState(null); // {invariato}|{nuove,non_dovute,esempi}|{error}
  const antBusy = React.useRef(false);
  const saveBusy = React.useRef(false);
  const [busyTick, setBusyTick] = React.useState(0);

  React.useEffect(() => {
    let vivo = true;
    setDati((d) => ({ ...d, loading: true, error: null }));
    readProfilo(win).then(
      (p) => {
        if (!vivo) return;
        setDati({ loading: false, error: null, p });
        setForm({
          ragione_sociale: p.ragione_sociale == null ? '' : p.ragione_sociale,
          partita_iva: p.partita_iva == null ? '' : p.partita_iva,
          codice_fiscale: p.codice_fiscale == null ? '' : p.codice_fiscale,
          codice_ateco: p.codice_ateco == null ? '' : p.codice_ateco,
          forma_giuridica: p.forma_giuridica || FORMA_GIURIDICA[0],
          regime_iva: p.regime_iva || REGIME_IVA[0],
          mese_chiusura_esercizio: p.mese_chiusura_esercizio == null ? '' : String(p.mese_chiusura_esercizio),
          giorno_chiusura_esercizio: p.giorno_chiusura_esercizio == null ? '' : String(p.giorno_chiusura_esercizio),
          pat_principale: p.pat_principale == null ? '' : p.pat_principale,
        });
        setBoolState(boolStateIniziale(p));
      },
      (e) => { if (vivo) setDati((d) => ({ ...d, loading: false, error: e })); }
    );
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [win, reloadN]);

  const setF = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const toggleBool = (k) => setBoolState((s) => ({ ...s, [k]: !s[k] }));

  const onAnteprima = () => {
    if (antBusy.current) return;
    antBusy.current = true; setBusyTick((n) => n + 1);
    anteprima(win, boolState).then(
      (res) => {
        if (!res.nuove && !res.non_dovute) setAnt({ invariato: true });
        else setAnt({ nuove: res.nuove, non_dovute: res.non_dovute, esempi: res.esempi || [] });
        antBusy.current = false; setBusyTick((n) => n + 1);
      },
      (e) => { setAnt({ error: e.message }); antBusy.current = false; setBusyTick((n) => n + 1); }
    );
  };

  const onSalva = () => {
    if (saveBusy.current) return;                       // D-A6.1: doppio salva = 1 PATCH
    saveBusy.current = true; setBusyTick((n) => n + 1);
    const payload = buildProfiloPayload(form, boolState);
    salvaProfilo(win, payload).then(
      (resp) => { A.toast(saveToast(resp && resp.rigenerazione)); saveBusy.current = false; setBusyTick((n) => n + 1); },
      (e) => { win.alert(PA_TEXTS.errorePrefix + e.message); saveBusy.current = false; setBusyTick((n) => n + 1); }
    );
  };

  if (dati.loading) return <div className="dt-state dt-loading" role="status"><span className="dt-spin" /><span>{PA_TEXTS.caricamento}</span></div>;
  if (dati.error || !form) {
    return (
      <>
        <IntestazionePagina onAnteprima={null} onSalva={null} isAdmin={false} antBusy={false} saveBusy={false} />
        <ErroreRicarica error={dati.error || new Error('profilo non disponibile')} onRetry={() => setReloadN((n) => n + 1)} />
      </>
    );
  }

  const antBusyNow = antBusy.current;
  const saveBusyNow = saveBusy.current;

  return (
    <>
      <IntestazionePagina onAnteprima={onAnteprima} onSalva={onSalva} isAdmin={A.isAdmin()} antBusy={antBusyNow} saveBusy={saveBusyNow} />

      {ant ? (
        <div id="amm-anteprima-impatto-out" className="max-w-3xl mb-4 px-4 py-3 rounded-lg text-sm bg-slate-50 border">
          {ant.error ? (
            <div className="text-rose-600">{"Errore nell'anteprima: " + ant.error}</div>
          ) : ant.invariato ? (
            <div className="text-slate-600">{PA_TEXTS.anteprimaInvariato}</div>
          ) : (
            <>
              <div className="font-medium text-slate-800 mb-1">{PA_TEXTS.seSalvi}</div>
              <div className="text-slate-700">
                {ant.nuove ? <><b>{ant.nuove}</b>{anteprimaNuoveSuffix(ant.nuove)}</> : PA_TEXTS.nessunaNuova}
                {ant.non_dovute ? <>{' · '}<b>{ant.non_dovute}</b>{anteprimaNonDovuteSuffix(ant.non_dovute)}</> : null}
              </div>
              {ant.esempi && ant.esempi.length ? (
                <ul className="list-disc list-inside text-xs text-slate-500 mt-2">
                  {ant.esempi.map((t, i) => <li key={i}>{t}</li>)}
                </ul>
              ) : null}
              <div className="text-[11px] text-slate-400 mt-2">{PA_TEXTS.anteprimaNota}</div>
            </>
          )}
        </div>
      ) : null}

      <div className="bg-white border rounded-lg p-5 max-w-3xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
          <Fld label={PA_TEXTS.lRagioneSociale} id="p-rs" value={form.ragione_sociale} onChange={(v) => setF('ragione_sociale', v)} />
          <Fld label={PA_TEXTS.lPartitaIva} id="p-piva" value={form.partita_iva} onChange={(v) => setF('partita_iva', v)} />
          <Fld label={PA_TEXTS.lCodiceFiscale} id="p-cf" value={form.codice_fiscale} onChange={(v) => setF('codice_fiscale', v)} />
          <Fld label={PA_TEXTS.lCodiceAteco} id="p-ateco" value={form.codice_ateco} onChange={(v) => setF('codice_ateco', v)} />
          <Sel label={PA_TEXTS.lFormaGiuridica} id="p-forma" value={form.forma_giuridica} onChange={(v) => setF('forma_giuridica', v)}
            options={FORMA_GIURIDICA.map((o) => [o, o.toUpperCase()])} />
          <Sel label={PA_TEXTS.lRegimeIva} id="p-iva" value={form.regime_iva} onChange={(v) => setF('regime_iva', v)}
            options={REGIME_IVA.map((o) => [o, o])} />
          <Fld label={PA_TEXTS.lMeseChiusura} id="p-mc" type="number" value={form.mese_chiusura_esercizio} onChange={(v) => setF('mese_chiusura_esercizio', v)} />
          <Fld label={PA_TEXTS.lGiornoChiusura} id="p-gc" type="number" value={form.giorno_chiusura_esercizio} onChange={(v) => setF('giorno_chiusura_esercizio', v)} />
          <FldHtml label={PA_TEXTS.lPatPrincipale} id="p-pat" value={form.pat_principale} onChange={(v) => setF('pat_principale', v)} />
        </div>
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">{PA_TEXTS.caratteristicheFiscali}</div>
        {BOOLS.map((b) => (
          <div key={b[0]} className="flex items-center justify-between py-2.5 border-t first:border-t-0">
            <div><div className="text-sm">{b[1]}</div><div className="text-xs text-slate-400">{b[2]}</div></div>
            <div className={'amm-tog ' + (boolState[b[0]] ? 'on' : 'off')} data-bool={b[0]} onClick={() => toggleBool(b[0])}><div className="k" /></div>
          </div>
        ))}
      </div>
    </>
  );
}

function IntestazionePagina({ onAnteprima, onSalva, isAdmin, antBusy, saveBusy }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div>
        <h1 className="text-xl font-semibold">{PA_TEXTS.title}</h1>
        <div className="text-xs text-slate-400">{PA_TEXTS.subtitle}</div>
      </div>
      <div className="flex items-center gap-2 amm-no-print">
        <button id="amm-anteprima-impatto" type="button" disabled={!onAnteprima || antBusy}
          className="bg-slate-200 hover:bg-slate-300 text-slate-800 text-sm px-3 py-2 rounded font-medium"
          onClick={onAnteprima || undefined}>{antBusy ? AM_NEW_TEXTS.attendere : PA_TEXTS.anteprima}</button>
        {isAdmin ? (
          <button id="amm-save-prof" type="button" disabled={saveBusy}
            className="bg-cyan-700 hover:bg-cyan-600 text-white text-sm px-3 py-2 rounded font-medium"
            onClick={onSalva || undefined}>{saveBusy ? AM_NEW_TEXTS.attendere : PA_TEXTS.salvaRigenera}</button>
        ) : null}
      </div>
    </div>
  );
}

function Fld({ label, id, value, onChange, type }) {
  return (
    <div>
      <label className="block text-xs text-slate-500 mb-1">{label}</label>
      <input id={id} type={type || 'text'} className="w-full border rounded px-2 py-1.5 text-sm" value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}
// campo con label che contiene HTML (es. il sotto-testo del PAT) — verbatim v1
function FldHtml({ label, id, value, onChange }) {
  return (
    <div>
      <label className="block text-xs text-slate-500 mb-1" dangerouslySetInnerHTML={{ __html: label }} />
      <input id={id} type="text" className="w-full border rounded px-2 py-1.5 text-sm" value={value} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}
function Sel({ label, id, value, onChange, options }) {
  return (
    <div>
      <label className="block text-xs text-slate-500 mb-1">{label}</label>
      <select id={id} className="w-full border rounded px-2 py-1.5 text-sm" value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}

// ---------- TIPOLOGIE DEL RESOCONTO (tabellare, editor v1) ----------
function TipologieSection({ win }) {
  const A = win.AMM;
  const [st, setSt] = React.useState({ loading: true, error: null, list: [] });
  const [reloadN, setReloadN] = React.useState(0);
  const newBusy = React.useRef(false);
  const reload = () => setReloadN((n) => n + 1);
  React.useEffect(() => {
    let vivo = true; setSt((s) => ({ ...s, loading: true, error: null }));
    readTipologie(win).then(
      (list) => { if (vivo) setSt({ loading: false, error: null, list }); },
      (e) => { if (vivo) setSt({ loading: false, error: e, list: [] }); }
    );
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [win, reloadN]);

  const onNew = () => {
    if (newBusy.current) return; newBusy.current = true;
    try { apriNuovaTipologia(win, () => { newBusy.current = false; reload(); }); }
    finally { setTimeout(() => { newBusy.current = false; }, 400); }
  };

  return (
    <div className="max-w-3xl mt-5">
      <SezioneHeader label={PA_TEXTS.tipologie} btnId="tip-new" btnLabel={PA_TEXTS.nuovaTipologia} onNew={onNew} />
      <div id="tip-list" className="bg-white border rounded-lg overflow-hidden">
        {st.loading ? <div className="p-4 text-center text-slate-400 text-sm">{PA_TEXTS.caricamento}</div>
          : st.error ? <div className="p-4 text-rose-600 text-sm">{PA_TEXTS.errorePrefix + st.error.message}</div>
            : !st.list.length ? <div className="p-8 text-center text-slate-500 text-sm">{PA_TEXTS.emptyTipologie}</div>
              : (
                <table className="w-full text-sm"><tbody>
                  {st.list.map((t) => (
                    <tr key={t.id} className="border-t first:border-0">
                      <td className="px-4 py-2.5" style={{ width: 24 }}>
                        <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: t.colore || '#64748b' }} />
                      </td>
                      <td className="px-2 py-2.5 flex-1">{t.nome}</td>
                      <td className="px-4 py-2.5 text-slate-400 text-xs" style={{ width: 70 }}>{PA_TEXTS.ordinePrefix + (t.ordine != null ? t.ordine : 0)}</td>
                      <td className="px-4 py-2.5 text-right" style={{ width: 50 }}>
                        <button type="button" className="amm-tip-edit text-cyan-700 hover:text-cyan-900 text-xs" onClick={() => apriEditTipologia(win, t, reload)}>{PA_TEXTS.modifica}</button>
                      </td>
                    </tr>
                  ))}
                </tbody></table>
              )}
      </div>
    </div>
  );
}

// ---------- PARAMETRI NORMATIVI (tabellare, editor v1) ----------
function ParametriSection({ win }) {
  const A = win.AMM;
  const [st, setSt] = React.useState({ loading: true, error: null, list: [] });
  const [reloadN, setReloadN] = React.useState(0);
  const newBusy = React.useRef(false);
  const delBusy = React.useRef({});
  const reload = () => setReloadN((n) => n + 1);
  React.useEffect(() => {
    let vivo = true; setSt((s) => ({ ...s, loading: true, error: null }));
    readParametri(win).then(
      (list) => { if (vivo) setSt({ loading: false, error: null, list }); },
      (e) => { if (vivo) setSt({ loading: false, error: e, list: [] }); }
    );
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [win, reloadN]);

  const onNew = () => {
    if (newBusy.current) return; newBusy.current = true;
    try { apriNuovoParametro(win, () => { newBusy.current = false; reload(); }); }
    finally { setTimeout(() => { newBusy.current = false; }, 400); }
  };
  const onDel = (rec) => {
    const k = 'd' + rec.id;
    if (delBusy.current[k]) return;
    if (!win.confirm(confirmParametro(rec.chiave || rec.id))) return;
    delBusy.current[k] = true;
    eliminaParametro(win, rec.id, () => { A.toast(PA_TEXTS.toastParametroEliminato); delBusy.current[k] = false; reload(); })
      .catch(() => { delBusy.current[k] = false; });
  };

  return (
    <div className="max-w-3xl mt-5">
      <SezioneHeader label={PA_TEXTS.parametri} btnId="par-new" btnLabel={PA_TEXTS.nuovoParametro} onNew={onNew} />
      <div id="par-list" className="bg-white border rounded-lg overflow-hidden">
        {st.loading ? <div className="p-4 text-center text-slate-400 text-sm">{PA_TEXTS.caricamento}</div>
          : st.error ? <div className="p-4 text-rose-600 text-sm">{PA_TEXTS.errorePrefix + st.error.message}</div>
            : !st.list.length ? <div className="p-8 text-center text-slate-500 text-sm">{PA_TEXTS.emptyParametri}</div>
              : (
                <table className="w-full text-sm"><tbody>
                  {st.list.map((r) => (
                    <tr key={r.id} className="border-t first:border-0">
                      <td className="px-4 py-2.5 font-mono text-xs">
                        {r.chiave}
                        {parametroDaConfermare(r.note) ? <>{' '}<span className="amm-badge" style={{ background: '#fef3c7', color: '#92400e' }}>{IC_WARN}</span></> : null}
                      </td>
                      <td className="px-2 py-2.5">{r.valore}</td>
                      <td className="px-2 py-2.5 text-xs text-slate-500">{parametroValiditaTxt(r.valido_dal, r.valido_al)}</td>
                      <td className="px-2 py-2.5 text-xs text-slate-400">{r.fonte || PA_TEXTS.dash}</td>
                      <td className="px-4 py-2.5 text-right whitespace-nowrap" style={{ width: 70 }}>
                        <span className="amm-par-edit text-slate-400 hover:text-cyan-700 cursor-pointer text-xs" title="Modifica" onClick={() => apriEditParametro(win, r, reload)}>{IC_EDIT}</span>{' '}
                        {A.isAdmin() ? <span className="amm-par-del text-slate-400 hover:text-rose-700 cursor-pointer text-xs" title="Elimina" onClick={() => onDel(r)}>{IC_DEL}</span> : null}
                      </td>
                    </tr>
                  ))}
                </tbody></table>
              )}
      </div>
      <p className="text-xs text-slate-400 mt-2">{PA_TEXTS.parametriHint}</p>
    </div>
  );
}

// ---------- PROROGHE (tabellare, editor v1; regole per titolo + select) ----------
function ProrogheSection({ win }) {
  const A = win.AMM;
  const [st, setSt] = React.useState({ loading: true, error: null, list: [], regole: [] });
  const [reloadN, setReloadN] = React.useState(0);
  const newBusy = React.useRef(false);
  const delBusy = React.useRef({});
  const reload = () => setReloadN((n) => n + 1);
  React.useEffect(() => {
    let vivo = true; setSt((s) => ({ ...s, loading: true, error: null }));
    readProrogheERegole(win).then(
      ({ list, regole }) => { if (vivo) setSt({ loading: false, error: null, list, regole }); },
      (e) => { if (vivo) setSt({ loading: false, error: e, list: [], regole: [] }); }
    );
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [win, reloadN]);

  const onNew = () => {
    if (newBusy.current) return; newBusy.current = true;
    try { apriNuovaProroga(win, st.regole, () => { newBusy.current = false; reload(); }); }
    finally { setTimeout(() => { newBusy.current = false; }, 400); }
  };
  const onDel = (rec) => {
    const k = 'd' + rec.id;
    if (delBusy.current[k]) return;
    if (!win.confirm(PA_TEXTS.confirmProroga)) return;
    delBusy.current[k] = true;
    eliminaProroga(win, rec.id, () => { A.toast(PA_TEXTS.toastProrogaEliminata); delBusy.current[k] = false; reload(); })
      .catch(() => { delBusy.current[k] = false; });
  };

  return (
    <div className="max-w-3xl mt-5">
      <SezioneHeader label={PA_TEXTS.proroghe} btnId="pro-new" btnLabel={PA_TEXTS.nuovaProroga} onNew={onNew} />
      <div id="pro-list" className="bg-white border rounded-lg overflow-hidden">
        {st.loading ? <div className="p-4 text-center text-slate-400 text-sm">{PA_TEXTS.caricamento}</div>
          : st.error ? <div className="p-4 text-rose-600 text-sm">{PA_TEXTS.errorePrefix + st.error.message}</div>
            : !st.list.length ? <div className="p-8 text-center text-slate-500 text-sm">{PA_TEXTS.emptyProroghe}</div>
              : (
                <table className="w-full text-sm"><tbody>
                  {st.list.map((r) => (
                    <tr key={r.id} className="border-t first:border-0">
                      <td className="px-4 py-2.5">
                        <div className="font-medium">{prorogaTitoloRegola(r.regola_codice, st.regole)}</div>
                        <div className="text-[11px] text-slate-400 font-mono">{r.regola_codice}</div>
                      </td>
                      <td className="px-2 py-2.5 text-xs">{r.anno}</td>
                      <td className="px-2 py-2.5 text-xs text-slate-500">{prorogaDataOriginaleTxt(r.data_originale)}</td>
                      <td className="px-2 py-2.5 text-xs">{dd(r.data_prorogata)}</td>
                      <td className="px-2 py-2.5 text-xs text-slate-400">{r.fonte || PA_TEXTS.dash}</td>
                      <td className="px-4 py-2.5 text-right whitespace-nowrap" style={{ width: 70 }}>
                        <span className="amm-pro-edit text-slate-400 hover:text-cyan-700 cursor-pointer text-xs" title="Modifica" onClick={() => apriEditProroga(win, r, st.regole, reload)}>{IC_EDIT}</span>{' '}
                        {A.isAdmin() ? <span className="amm-pro-del text-slate-400 hover:text-rose-700 cursor-pointer text-xs" title="Elimina" onClick={() => onDel(r)}>{IC_DEL}</span> : null}
                      </td>
                    </tr>
                  ))}
                </tbody></table>
              )}
      </div>
    </div>
  );
}

// ====================================================================
// A7 (ondata 37) — i 4 pannelli oggi NATIVI React (prima delegati ai
// renderX del v1). Parità campo-per-campo col v1: STESSE letture, STESSI
// testi (PA_TEXTS pinnati), STESSI id/classi WORLD-AGNOSTIC (prom-tog,
// reg-f-entita, cest-rip…) così il proof li trova nei due mondi. Le
// SCRITTURE che il v1 fa via primitive delegano: Promemoria salva →
// AMM.upsertParametroVigente; Cestino Ripristina → stesso endpoint NON
// distruttivo (nel v1 il cestino NON ha "svuota"/hard-delete).
// ====================================================================

// ---------- SPAZIO ALLEGATI (sola lettura) ----------
function SpazioAllegatiSection({ win }) {
  const [st, setSt] = React.useState({ loading: true, error: null, data: null });
  React.useEffect(() => {
    let vivo = true; setSt((s) => ({ ...s, loading: true, error: null }));
    readSpazio(win).then(
      (res) => { if (vivo) setSt({ loading: false, error: null, data: res }); },
      (e) => { if (vivo) setSt({ loading: false, error: e, data: null }); }
    );
    return () => { vivo = false; };
  }, [win]);

  let inner;
  if (st.loading) inner = <div className="text-center text-slate-400 text-sm py-3">{PA_TEXTS.caricamento}</div>;
  else if (st.error) inner = <div className="text-rose-600 text-xs">{PA_TEXTS.spazioErrore + (st.error.message || String(st.error))}</div>;
  else {
    const res = st.data || {};
    const totale = res.totale_bytes || 0;
    const top = res.top || [];
    inner = (
      <>
        <div className="flex items-center gap-6 mb-3">
          <div><div className="text-[10px] uppercase tracking-wide text-slate-400">{PA_TEXTS.spazioTotale}</div><div className="text-lg font-semibold">{humanBytes(totale)}</div></div>
          <div><div className="text-[10px] uppercase tracking-wide text-slate-400">{PA_TEXTS.spazioFile}</div><div className="text-lg font-semibold">{res.count || 0}</div></div>
        </div>
        {top.length ? (
          <>
            <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-1">{PA_TEXTS.spazioTopPrefix + top.length + PA_TEXTS.spazioTopSuffix}</div>
            <div className="border rounded-lg overflow-hidden"><table className="w-full text-xs"><tbody>
              {top.map((a, i) => (
                <tr key={a.id != null ? a.id : i} className="border-t first:border-0">
                  <td className="px-2 py-1.5 truncate" style={{ maxWidth: 280 }} title={a.filename}>{a.filename}</td>
                  <td className="px-2 py-1.5 text-slate-400 whitespace-nowrap">{fmtDataSola(a.created_at)}</td>
                  <td className="px-2 py-1.5 text-right font-medium whitespace-nowrap">{humanBytes(a.size)}</td>
                </tr>
              ))}
            </tbody></table></div>
          </>
        ) : <div className="text-xs text-slate-400">{PA_TEXTS.spazioVuoto}</div>}
      </>
    );
  }
  return <div className="bg-white border rounded-lg p-5">{inner}</div>;
}

// ---------- REGISTRO MODIFICHE (sola lettura: filtri + paginazione "mostra altri") ----------
function OrigineBadge({ origine }) {
  const b = origineBadge(origine);
  return <span className="amm-badge" style={{ background: b.bg, color: b.fg }}>{b.label}</span>;
}
function RegistroModificheSection({ win }) {
  const [filtri, setFiltri] = React.useState({ entita: '', autore: '', dal: '', al: '' });
  const [autoreInput, setAutoreInput] = React.useState('');
  const [st, setSt] = React.useState({ loading: true, error: null, righe: [], totale: 0, altre: false, offset: 0 });
  const debounceRef = React.useRef(null);
  const altriBusy = React.useRef(false);

  // reset load a ogni cambio filtri (v1 carica(true))
  React.useEffect(() => {
    let vivo = true;
    setSt((s) => ({ ...s, loading: true, error: null }));
    readStoriaRegistro(win, { ...filtri, limit: REG_LIMIT, offset: 0 }).then(
      (res) => { if (vivo) setSt({ loading: false, error: null, righe: res.righe || [], totale: res.totale || 0, altre: !!res.altre, offset: 0 }); },
      (e) => { if (vivo) setSt({ loading: false, error: e, righe: [], totale: 0, altre: false, offset: 0 }); }
    );
    return () => { vivo = false; };
  }, [win, filtri]);

  const setF = (k, v) => setFiltri((f) => ({ ...f, [k]: v }));
  const onAutore = (v) => {                                  // v1: debounce 350ms
    setAutoreInput(v);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => setFiltri((f) => ({ ...f, autore: v })), 350);
  };
  const onMostraAltri = () => {                              // v1 carica(false): append
    if (altriBusy.current) return; altriBusy.current = true;
    const nextOffset = st.offset + REG_LIMIT;
    readStoriaRegistro(win, { ...filtri, limit: REG_LIMIT, offset: nextOffset }).then(
      (res) => { setSt((s) => ({ ...s, righe: s.righe.concat(res.righe || []), totale: res.totale || 0, altre: !!res.altre, offset: nextOffset })); altriBusy.current = false; },
      (e) => { setSt((s) => ({ ...s, error: e })); altriBusy.current = false; }
    );
  };

  let table;
  if (st.loading && !st.righe.length) table = <div className="text-xs text-slate-400 py-3">{PA_TEXTS.caricamento}</div>;
  else if (!st.righe.length) table = <div className="text-xs text-slate-400 py-3">{PA_TEXTS.regVuoto}</div>;
  else table = (
    <div style={{ maxHeight: '22rem', overflow: 'auto' }} className="border rounded"><table className="w-full text-xs"><tbody>
      {st.righe.map((r, i) => (
        <tr key={i} className="border-t first:border-0">
          <td className="px-2 py-1.5 text-slate-400 whitespace-nowrap">{fmtDataOra(r.created_at)}</td>
          <td className="px-2 py-1.5 text-slate-500 whitespace-nowrap">{r.utente || PA_TEXTS.dash}</td>
          <td className="px-2 py-1.5 whitespace-nowrap">{STORIA_ENTITA_LABEL[r.entita] || r.entita}</td>
          <td className="px-2 py-1.5 font-medium whitespace-nowrap">{r.campo}</td>
          <td className="px-2 py-1.5 text-slate-600">{r.valore_prima}{' ' + ARROW + ' '}{r.valore_dopo}</td>
          <td className="px-2 py-1.5 whitespace-nowrap"><OrigineBadge origine={r.origine} /></td>
        </tr>
      ))}
    </tbody></table></div>
  );

  return (
    <div className="bg-white border rounded-lg p-5">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
        <div><label className="block text-xs text-slate-500 mb-1">{PA_TEXTS.regEntita}</label>
          <select id="reg-f-entita" className="w-full border rounded px-2 py-1.5 text-sm" value={filtri.entita} onChange={(e) => setF('entita', e.target.value)}>
            <option value="">{PA_TEXTS.regTutte}</option>
            {Object.keys(STORIA_ENTITA_LABEL).map((k) => <option key={k} value={k}>{STORIA_ENTITA_LABEL[k]}</option>)}
          </select></div>
        <div><label className="block text-xs text-slate-500 mb-1">{PA_TEXTS.regAutore}</label>
          <input id="reg-f-autore" className="w-full border rounded px-2 py-1.5 text-sm" value={autoreInput} placeholder={PA_TEXTS.regAutorePh} onChange={(e) => onAutore(e.target.value)} /></div>
        <div><label className="block text-xs text-slate-500 mb-1">{PA_TEXTS.regDal}</label>
          <input id="reg-f-dal" type="date" className="w-full border rounded px-2 py-1.5 text-sm" value={filtri.dal} onChange={(e) => setF('dal', e.target.value)} /></div>
        <div><label className="block text-xs text-slate-500 mb-1">{PA_TEXTS.regAl}</label>
          <input id="reg-f-al" type="date" className="w-full border rounded px-2 py-1.5 text-sm" value={filtri.al} onChange={(e) => setF('al', e.target.value)} /></div>
      </div>
      {st.error ? <div id="reg-err" className="mb-3 px-3 py-2 rounded bg-rose-50 border border-rose-200 text-rose-700 text-xs">{PA_TEXTS.regErrore + (st.error.message || String(st.error))}</div> : null}
      <div id="reg-table">{table}</div>
      <div className="mt-3 flex items-center justify-between">
        <div id="reg-count" className="text-xs text-slate-400">{registroContaTesto(st.righe.length, st.totale)}</div>
        {st.altre ? <button id="reg-altri" type="button" className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs px-3 py-1.5 rounded font-medium" onClick={onMostraAltri}>{PA_TEXTS.regMostraAltri}</button> : null}
      </div>
    </div>
  );
}

// ---------- CESTINO (elenco cestinati + Ripristina NON distruttivo) ----------
// Il v1 NON espone alcuno "svuota"/hard-delete del cestino: solo list +
// ripristina. Il nativo replica ESATTAMENTE (nessuna cancellazione definitiva
// introdotta). Il Ripristina chiama lo STESSO endpoint del v1.
function CestinoSection({ win }) {
  const A = win.AMM;
  const [st, setSt] = React.useState({ loading: true, error: null, righe: [] });
  const [reloadN, setReloadN] = React.useState(0);
  const ripBusy = React.useRef({});

  React.useEffect(() => {
    let vivo = true; setSt((s) => ({ ...s, loading: true, error: null }));
    readCestino(win).then(
      (righe) => { if (vivo) setSt({ loading: false, error: null, righe: righe || [] }); },
      (e) => { if (vivo) setSt({ loading: false, error: e, righe: [] }); }
    );
    return () => { vivo = false; };
  }, [win, reloadN]);

  const onRipristina = (r) => {                              // doppio click = 1 (guardia ref)
    const k = r.entita + ':' + r.id;
    if (ripBusy.current[k]) return; ripBusy.current[k] = true;
    ripristinaCestino(win, r.entita, r.id).then(
      () => { A.toast(PA_TEXTS.cestRipristinato); ripBusy.current[k] = false; setReloadN((n) => n + 1); },
      (e) => { ripBusy.current[k] = false; win.alert(PA_TEXTS.cestRipristinoKo + e.message); }  // rete KO rumorosa (parità v1)
    );
  };

  let inner;
  if (st.loading) inner = <div className="text-center text-slate-400 text-sm py-3">{PA_TEXTS.caricamento}</div>;
  else if (st.error) inner = <div className="text-rose-600 text-xs">{PA_TEXTS.cestErrore + (st.error.message || String(st.error))}</div>;
  else if (!st.righe.length) inner = <div className="text-xs text-slate-400 py-3">{PA_TEXTS.cestVuoto}</div>;
  else inner = (
    <>
      <div style={{ maxHeight: '22rem', overflow: 'auto' }} className="border rounded"><table className="w-full text-xs"><tbody>
        {st.righe.map((r) => (
          <tr key={r.entita + ':' + r.id} data-entita={r.entita} data-id={r.id} className="border-t first:border-0">
            <td className="px-2 py-1.5 whitespace-nowrap">{CEST_ENTITA_LABEL[r.entita] || r.entita}</td>
            <td className="px-2 py-1.5">{r.titolo || r.id}
              {r.doppione_unito_in ? <>{' '}<span className="inline-block bg-slate-200 text-slate-600 text-[10px] px-1.5 py-0.5 rounded ml-1" title={'Doppione unito in ' + r.doppione_unito_in}>{PA_TEXTS.cestDoppionePrefix + r.doppione_unito_in}</span></> : null}</td>
            <td className="px-2 py-1.5 text-slate-400 whitespace-nowrap">{fmtDataOra(r.deleted_at)}</td>
            <td className="px-2 py-1.5 text-slate-500 whitespace-nowrap">{r.cestinato_da || PA_TEXTS.dash}</td>
            <td className="px-2 py-1.5 text-right">{A.isAdmin() ? <button type="button" className="cest-rip bg-cyan-700 hover:bg-cyan-600 text-white text-xs px-2.5 py-1 rounded font-medium" onClick={() => onRipristina(r)}>{PA_TEXTS.cestRipristina}</button> : null}</td>
          </tr>
        ))}
      </tbody></table></div>
      <div className="text-xs text-slate-400 mt-2">{cestinoContaTesto(st.righe.length)}</div>
    </>
  );
  return <div className="bg-white border rounded-lg p-5">{inner}</div>;
}

// ---------- PROMEMORIA EMAIL (toggle + email + anticipo + pausa + invio prova + log) ----------
// SCRITTURA delegata: il salva chiama AMM.upsertParametroVigente ×5 (stessa
// primitiva v1 "update in place della riga vigente"). NESSUNA password: il v1
// espone solo l'email destinatario (verificato: zero campi password nel v1).
function EsitoBadge({ esito }) {
  return esito === 'ok'
    ? <span className="amm-badge" style={{ background: '#d1fae5', color: '#065f46' }}>{PA_TEXTS.promBadgeOk}</span>
    : <span className="amm-badge" style={{ background: '#fee2e2', color: '#991b1b' }}>{PA_TEXTS.promBadgeErrore}</span>;
}
function PromemoriaSection({ win }) {
  const A = win.AMM;
  const [dati, setDati] = React.useState({ loading: true, error: null, stato: null });
  const [reloadN, setReloadN] = React.useState(0);
  const [attivo, setAttivo] = React.useState(false);
  const [form, setForm] = React.useState({ email: '', anticipo: '', pausaDal: '', pausaAl: '' });
  const [pausaErr, setPausaErr] = React.useState('');
  const [testEsito, setTestEsito] = React.useState(null); // {text, cls}
  const saveBusy = React.useRef(false);
  const testBusy = React.useRef(false);
  const [, setBusyTick] = React.useState(0);

  React.useEffect(() => {
    let vivo = true;
    setDati((d) => ({ ...d, loading: true, error: null }));
    Promise.all([readPromemoriaStato(win), readParametri(win)]).then(
      ([stato, parametri]) => {
        if (!vivo) return;
        setDati({ loading: false, error: null, stato });
        setAttivo(!!stato.attivo);
        const anticipoVal = vigenteDiParametro(parametri, 'promemoria_anticipo_default');
        setForm({
          email: stato.email || '',
          anticipo: anticipoVal == null ? '' : String(anticipoVal),
          pausaDal: vigenteDiParametro(parametri, 'promemoria_pausa_dal') || '',
          pausaAl: vigenteDiParametro(parametri, 'promemoria_pausa_al') || '',
        });
        setPausaErr(''); setTestEsito(null);
      },
      (e) => { if (vivo) setDati((d) => ({ ...d, loading: false, error: e })); }
    );
    return () => { vivo = false; };
  }, [win, reloadN]);

  const setF = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onSalva = () => {
    if (saveBusy.current) return;                            // doppio click = 1 (D-A6.1)
    setPausaErr('');
    if (pausaIncompleta(form.pausaDal, form.pausaAl)) { setPausaErr(PA_TEXTS.promPausaIncompleta); return; } // guardia client v1
    saveBusy.current = true; setBusyTick((n) => n + 1);
    salvaPromemoria(win, { email: form.email.trim(), attivo, anticipo: form.anticipo.trim(), pausaDal: form.pausaDal, pausaAl: form.pausaAl }).then(
      () => { A.toast(PA_TEXTS.promSalvato); saveBusy.current = false; setReloadN((n) => n + 1); },
      (e) => { setPausaErr(PA_TEXTS.promDatiNonSalvati + promemoriaSalvaErrMsg(e)); saveBusy.current = false; setBusyTick((n) => n + 1); } // dati NON persi (restano nel form)
    );
  };

  const onTest = () => {
    if (testBusy.current) return; testBusy.current = true; setTestEsito(null); setBusyTick((n) => n + 1);
    inviaProvaPromemoria(win, form.email.trim()).then(
      (r) => { setTestEsito({ text: PA_TEXTS.promInviataA + r.inviato_a, cls: 'text-xs text-emerald-700' }); testBusy.current = false; setBusyTick((n) => n + 1); },
      (e) => { setTestEsito({ text: PA_TEXTS.promNonInviata + e.message, cls: 'text-xs text-rose-700' }); testBusy.current = false; setBusyTick((n) => n + 1); }
    );
  };

  if (dati.loading) return <div className="bg-white border rounded-lg p-5"><div className="text-center text-slate-400 text-sm py-3">{PA_TEXTS.caricamento}</div></div>;
  if (dati.error) return <div className="bg-white border rounded-lg p-5"><div className="text-rose-600 text-sm">{PA_TEXTS.errorePrefix + (dati.error.message || String(dati.error))}</div></div>;

  const stato = dati.stato || {};
  const saveBusyNow = saveBusy.current;
  const testBusyNow = testBusy.current;

  return (
    <div className="bg-white border rounded-lg p-5">
      <div className="flex items-center justify-between py-2">
        <div><div className="text-sm">{PA_TEXTS.promAttivi}</div><div className="text-xs text-slate-400">{PA_TEXTS.promAttiviDesc}</div></div>
        <div className={'amm-tog ' + (attivo ? 'on' : 'off')} id="prom-tog" onClick={() => setAttivo((a) => !a)}><div className="k" /></div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 items-end mt-3">
        <div><label className="block text-xs text-slate-500 mb-1">{PA_TEXTS.promEmail}</label>
          <input id="prom-email" type="email" className="w-full border rounded px-2 py-1.5 text-sm" value={form.email} placeholder={PA_TEXTS.promEmailPh} onChange={(e) => setF('email', e.target.value)} /></div>
        <button id="prom-save" type="button" disabled={saveBusyNow} className="bg-cyan-700 hover:bg-cyan-600 text-white text-sm px-3 py-2 rounded font-medium whitespace-nowrap" onClick={onSalva}>{saveBusyNow ? AM_NEW_TEXTS.attendere : PA_TEXTS.promSalva}</button>
      </div>
      <div className="flex items-center gap-3 mt-3">
        <button id="prom-test" type="button" disabled={testBusyNow} className="bg-slate-200 hover:bg-slate-300 text-slate-800 text-xs px-3 py-1.5 rounded font-medium" onClick={onTest}>{testBusyNow ? AM_NEW_TEXTS.attendere : PA_TEXTS.promTest}</button>
        <span id="prom-test-esito" className={testEsito ? testEsito.cls : 'text-xs'}>{testEsito ? testEsito.text : ''}</span>
      </div>
      <div className="mt-5 pt-4 border-t">
        <div><label className="block text-xs text-slate-500 mb-1">{PA_TEXTS.promAnticipo}</label>
          <input id="prom-anticipo" type="number" min="0" className="w-full max-w-[160px] border rounded px-2 py-1.5 text-sm" value={form.anticipo} placeholder={PA_TEXTS.promAnticipoPh} onChange={(e) => setF('anticipo', e.target.value)} /></div>
        <div className="text-xs text-amber-700 mt-1">{IC_WARN + ' ' + PA_TEXTS.promAnticipoWarn}</div>
      </div>
      <div className="mt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div><label className="block text-xs text-slate-500 mb-1">{PA_TEXTS.promPausaDal}</label>
            <input id="prom-pausa-dal" type="date" className="w-full border rounded px-2 py-1.5 text-sm" value={form.pausaDal} onChange={(e) => setF('pausaDal', e.target.value)} /></div>
          <div><label className="block text-xs text-slate-500 mb-1">{PA_TEXTS.promPausaAl}</label>
            <input id="prom-pausa-al" type="date" className="w-full border rounded px-2 py-1.5 text-sm" value={form.pausaAl} onChange={(e) => setF('pausaAl', e.target.value)} /></div>
        </div>
        <div className="text-xs text-slate-400 mt-1">{PA_TEXTS.promPausaHint}</div>
        {pausaErr ? <div id="prom-pausa-err" className="mt-2 px-3 py-2 rounded bg-rose-50 border border-rose-200 text-rose-700 text-xs">{pausaErr}</div> : null}
      </div>
      <div className="mt-5">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">{PA_TEXTS.promUltimiInvii}</div>
        {stato.log && stato.log.length ? (
          <table className="w-full text-sm border rounded overflow-hidden"><tbody>
            {stato.log.map((l, i) => (
              <tr key={i} className="border-t first:border-0">
                <td className="px-3 py-2 text-xs text-slate-400 whitespace-nowrap">{fmtPromemoriaLog(l.created_at)}</td>
                <td className="px-3 py-2 text-xs">{l.inviato_a || PA_TEXTS.dash}</td>
                <td className="px-3 py-2" style={{ width: 70 }}><EsitoBadge esito={l.esito} /></td>
                <td className="px-3 py-2 text-xs text-slate-400">{l.dettaglio || ''}</td>
              </tr>
            ))}
          </tbody></table>
        ) : <div className="p-4 text-center text-slate-400 text-sm border rounded">{PA_TEXTS.promNessunInvio}</div>}
      </div>
    </div>
  );
}

export function ProfiloView({ win }) {
  return (
    <div data-amm-v3="profilo">
      <SchedaAzienda win={win} />
      <TipologieSection win={win} />
      <ParametriSection win={win} />
      <ProrogheSection win={win} />

      {/* A7 (ondata 37): i 4 pannelli sono ora NATIVI React (prima delegati) */}
      <div className="max-w-3xl mt-5">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">{PA_TEXTS.promemoria}</div>
        <PromemoriaSection win={win} />
      </div>

      {/* Registro modifiche / Spazio allegati / Cestino — amm-no-print come il v1 */}
      <div className="max-w-3xl mt-5 amm-no-print">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">{PA_TEXTS.registroModifiche}</div>
        <RegistroModificheSection win={win} />
      </div>
      <div className="max-w-3xl mt-5 amm-no-print">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">{PA_TEXTS.spazioAllegati}</div>
        <SpazioAllegatiSection win={win} />
      </div>
      <div className="max-w-3xl mt-5 mb-10 amm-no-print">
        <div className="text-[11px] uppercase tracking-wider text-slate-400 mb-2">{PA_TEXTS.cestino}</div>
        <CestinoSection win={win} />
      </div>
    </div>
  );
}

// Factory (pattern createAmmV3Rateizzazioni): root React in #amm-page, marcatore
// [data-amm-v3="profilo"] FUORI dal quale vive il chrome v1 (rail/sidebar).
export function createAmmV3Profilo(win) {
  let root = null;
  let mountedEl = null;
  let tick = 0;

  function render() {
    const container = win.document.getElementById('amm-page');
    if (!container) throw new Error('#amm-page assente');
    const manomesso = root && mountedEl === container && tick > 0 && !container.querySelector('[data-amm-v3]');
    if (!root || mountedEl !== container || !container.isConnected || manomesso) {
      if (root) { try { root.unmount(); } catch (e) { /* root già ferito/smontato */ } }
      container.replaceChildren();
      root = win.ReactDOM.createRoot(container);
      mountedEl = container;
    }
    tick += 1; // usato solo dalla guardia anti-manomissione sopra
    root.render(<ProfiloView win={win} />);
  }

  function unmount() {
    if (root) {
      try { root.unmount(); } catch (e) { /* già smontato */ }
      root = null;
    }
    mountedEl = null;
  }

  function isMounted() { return !!root; }

  return { render, unmount, isMounted };
}
